var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "id_7 clear" }, [
    _vm.data.title
      ? _c("div", {
          staticClass: "title",
          domProps: { innerHTML: _vm._s(_vm.data.title) }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", {
        staticClass: "question",
        domProps: { innerHTML: _vm._s(_vm.data.question) }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", {
        staticClass: "answer",
        domProps: { innerHTML: _vm._s(_vm.data.answer) }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon clear" }, [
      _c("img", {
        staticClass: "fl",
        attrs: {
          src: "//img.webloom.cn/img/98a7f1d155dcd81668a644efa2ab5ce1.png"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bold span fl" }, [_vm._v("Q")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon clear" }, [
      _c("img", {
        staticClass: "fl",
        attrs: {
          src: "//img.webloom.cn/img/2d9a86c4615b2c0cd2b57e3f39be6f3c.png"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bold span fl" }, [_vm._v("A")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-805bdab0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-805bdab0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/id_7.vue
// module id = null
// module chunks = 